const exception = require('../../exception/index.js');

module.exports = (option)=>{
    const valiable_name_height="--navigation-height";
    const valiable_name_width="--navigation-width";

    let DOM_body = option.DOM['body'];
    let DOM_navigation = option.DOM['navigation'];

    let navigation_height = window.getComputedStyle(DOM_navigation).height;
    let navigation_width = window.getComputedStyle(DOM_navigation).width;

    DOM_body.style.setProperty(valiable_name_height,`${navigation_height}`);
    DOM_body.style.setProperty(valiable_name_width,`${navigation_width}`);
}


